import React from "react";
import { PageContainerDiv } from "./styles";

const PageContainer = ({ children }) => {
  return <PageContainerDiv>{children}</PageContainerDiv>;
};

export default PageContainer;
